import React from 'react';
import { useOpts } from '../../context';
import useOrgName from '../../hooks/useOrgName';
import { TemplateContinue } from '../../components/TemplateContinue';
import useAmountSelectionButtonText from '../../LinkApiRouter/hooks/useAmountSelectionButtonText';
import useSkipDepositConfirmation from '../../LinkApiRouter/hooks/useSkipDepositConfirmation';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
function RemoveAllocations(props) {
    var getLocalizedString = useGetLocalizedString();
    var setAmountSelection = useOpts().setAmountSelection;
    var orgName = useOrgName();
    var onContinue = function () {
        setAmountSelection({
            action: 'partial_switch',
            allocation: { type: 'amount', value: 0 },
        });
        props.onContinue();
    };
    useSkipDepositConfirmation(onContinue);
    var buttonText = useAmountSelectionButtonText();
    return (React.createElement(TemplateContinue, { title: getLocalizedString('CONFIRM_DEPOSIT_SETTINGS'), subtitle: getLocalizedString('REMOVE_EXISTING_ALLOCATIONS_TO_ORGNAME', [
            orgName,
        ]), onContinue: onContinue, buttonLabel: buttonText, buttonEventId: "AmountSelection-continue" }));
}
export default RemoveAllocations;
